"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var types_1 = require("../types");
var InputBox_1 = require("../helpers/InputBox");
var InputControl_1 = require("../helpers/InputControl");
var useControlState_1 = require("../helpers/useControlState");
var types_2 = require("./types");
var helpers_1 = require("../../helpers");
var icons_1 = require("../../icons");
var useEnterKeyStopPropagation_1 = require("../../helpers/useEnterKeyStopPropagation");
var public_1 = require("../../common/public");
exports.MIN_WIDTH_SEARCH = '88px';
var StyledInputBox = styled_components_1.default(InputBox_1.InputBox)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    min-width: ", ";\n"], ["\n    min-width: ", ";\n"])), exports.MIN_WIDTH_SEARCH);
exports.Search = helpers_1.createUIElement('Search', function (_a, ref) {
    var className = _a.className, placeholder = _a.placeholder, performed = _a.performed, _b = _a.size, size = _b === void 0 ? public_1.CONTROL_SIZE.m : _b, disabled = _a.disabled, value = _a.value, maxLength = _a.maxLength, onChange = _a.onChange, onClear = _a.onClear, onSearch = _a.onSearch, _c = _a.mode, mode = _c === void 0 ? types_2.SEARCH_MODE.compulsory : _c, hasSearchButton = _a.hasSearchButton, renderRightAddon = _a.renderRightAddon, _d = _a.searchDebounceTimeInMs, searchDebounceTimeInMs = _d === void 0 ? 250 : _d, _e = _a.hasEnterKeyStopPropagation, hasEnterKeyStopPropagation = _e === void 0 ? true : _e, onFocus = _a.onFocus, onBlur = _a.onBlur, onMouseEnter = _a.onMouseEnter, onMouseLeave = _a.onMouseLeave, onKeyDown = _a.onKeyDown, onKeyUp = _a.onKeyUp, onKeyPress = _a.onKeyPress, style = _a.style, rest = __rest(_a, ["className", "placeholder", "performed", "size", "disabled", "value", "maxLength", "onChange", "onClear", "onSearch", "mode", "hasSearchButton", "renderRightAddon", "searchDebounceTimeInMs", "hasEnterKeyStopPropagation", "onFocus", "onBlur", "onMouseEnter", "onMouseLeave", "onKeyDown", "onKeyUp", "onKeyPress", "style"]);
    var performedState = helpers_1.useStateValue(performed, [performed]);
    var _f = helpers_1.useStateValue(value, [value], {
        onChange: function (v) { return onChange === null || onChange === void 0 ? void 0 : onChange(v || ''); }
    }), setValue = _f.setValue, getValue = _f.getValue;
    hasSearchButton = hasSearchButton !== null && hasSearchButton !== void 0 ? hasSearchButton : (mode === types_2.SEARCH_MODE.compulsory || !getValue());
    var _g = useControlState_1.useControlState({
        rootRef: ref
    }), focused = _g.focused, active = _g.active, blur = _g.blur, focus = _g.focus, input = _g.input, activate = _g.activate, deactivate = _g.deactivate, preventBlur = _g.preventBlur;
    var search = helpers_1.useDebounceCallback(function () {
        onSearch === null || onSearch === void 0 ? void 0 : onSearch(getValue() || '');
        performedState.setValue(!!getValue());
    }, searchDebounceTimeInMs);
    var inputRef = useEnterKeyStopPropagation_1.useEnterKeyStopPropagation({
        hasStopPropagation: hasEnterKeyStopPropagation,
        onKeyEnterPress: function (e) {
            if (e.keyCode === helpers_1.KeyCode.Enter) {
                search();
            }
        }
    }).ref;
    var clear = function () {
        var _a;
        setValue('');
        performedState.setValue(false);
        (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.focus();
        onClear === null || onClear === void 0 ? void 0 : onClear();
    };
    var rightAddon = renderRightAddon === null || renderRightAddon === void 0 ? void 0 : renderRightAddon({
        disabled: !!disabled,
        activate: activate,
        deactivate: deactivate,
        blur: blur,
        focus: focus,
        preventBlur: preventBlur
    });
    return (react_1.default.createElement(StyledInputBox, __assign({}, rest, { "data-selector-id": rest['data-selector-id'] || 'search', className: "vm-Search " + className, tabIndex: -1, performed: performedState.getValue() && !focused, isFocused: focused, isActive: active, size: size < public_1.CONTROL_SIZE.s ? public_1.CONTROL_SIZE.s : size, isDisabled: disabled, actions: [
            !!value &&
                !disabled && {
                icon: react_1.default.createElement(icons_1.ClearIcon, { disabled: disabled }),
                onClick: clear,
                testId: 'clear-action'
            },
            !!hasSearchButton && {
                icon: react_1.default.createElement(icons_1.SearchIcon, { disabled: disabled }),
                onClick: search,
                testId: 'search-action'
            }
        ], hasRightAddonSeparator: true, rightAddon: rightAddon, onFocus: function (e) {
            input.onFocus(e);
            onFocus === null || onFocus === void 0 ? void 0 : onFocus(e);
        }, onBlur: function (e) {
            input.onBlur(e);
            onBlur === null || onBlur === void 0 ? void 0 : onBlur(e);
            if (!getValue()) {
                performedState.setValue(false);
            }
        }, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onKeyDown: onKeyDown, onKeyUp: onKeyUp, onKeyPress: onKeyPress, ref: ref, style: style }),
        react_1.default.createElement(InputControl_1.InputControl, { "data-selector-id": "search-input", ref: inputRef, value: getValue() || '', hasEnterKeyStopPropagation: hasEnterKeyStopPropagation, onChange: function (e) {
                setValue(e.target.value || '');
                if (mode === types_2.SEARCH_MODE.automatic) {
                    search();
                }
            }, placeholder: placeholder, onKeyPress: onKeyDown, disabled: disabled, type: types_1.INPUT_TYPE.text, maxLength: maxLength })));
});
var templateObject_1;
//# sourceMappingURL=Search.js.map